import Vue from 'vue';
import Antd from 'ant-design-vue';
import { Button } from 'ant-design-vue';
import { Icon } from 'ant-design-vue';
import { Form } from 'ant-design-vue';
import { FormModel } from 'ant-design-vue';
import { Space } from 'ant-design-vue';
import { Select } from 'ant-design-vue';
import { Checkbox } from 'ant-design-vue';
import { Radio } from 'ant-design-vue';
import { Dropdown } from 'ant-design-vue';
import { Input } from 'ant-design-vue';
import { Menu } from 'ant-design-vue';
import { Tooltip } from 'ant-design-vue';
import { Table } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
import { Popconfirm } from 'ant-design-vue';
import { Skeleton } from 'ant-design-vue';
import { Popover } from 'ant-design-vue';
import { Slider } from 'ant-design-vue';
import { TreeSelect, Drawer, Col, Row, InputNumber, Pagination, Breadcrumb, message, Upload, Divider, Tabs, Spin, Tag, Empty, Collapse, DatePicker, TimePicker, Card, Avatar, Comment } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Button)
Vue.use(Icon)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Space)
Vue.use(Select)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Input)
Vue.use(Menu)
Vue.use(Tooltip)
Vue.use(Table)
Vue.use(Modal)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Slider)
Vue.use(TreeSelect)
Vue.use(Col)
Vue.use(Row)
Vue.use(InputNumber)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Breadcrumb)
Vue.use(Divider)
Vue.use(Tabs)
Vue.use(Spin)
Vue.use(Tag)
Vue.use(Skeleton)
Vue.use(Empty)
Vue.use(Collapse)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Card)
Vue.use(Avatar)
Vue.use(Comment)
Vue.use(Drawer)
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$message = message
Vue.prototype.$info = Modal.info
Vue.prototype.$warning = Modal.warning
Vue.prototype.$modal = Modal

export default ({ app }) => {
  app.$message = message
}
